if (!customElements.get('shoe-finder-quiz')) {
  customElements.define(
    'shoe-finder-quiz',
    class ShoeFinderQuiz extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        this.addEventListener('submit', (e) => {
          e.preventDefault();          
          const gender = this.querySelector('[data-gender-selector]')?.value;
          const collection = this.querySelector('[data-condition-selector]')?.value;
          const style = this.querySelector('[data-style-selector]')?.value;
          const width = this.querySelector('[data-width-selector]')?.value;
          const filterString = `collections:${collection} AND (${width}) AND (${style}) ${gender ? `AND (${gender})` : ''}`;
          
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.set('filters', encodeURI(filterString));
          
          window.location.href = (`Filtered Collection - ${this.collectionHandle}`, '', `/collections/${collection}?${searchParams.toString()}`);
        })
      }
    }
  );
}